import {
  AppData,
  CalcMode,
  Calculator,
} from "../../interface/functionalityInterface";
import { Acceleration } from "../baseQuantities/acceleration";
import { Density } from "../baseQuantities/density";
import { Length } from "../baseQuantities/length";
import { Pressure } from "../baseQuantities/pressure";
import { waterData } from "../catalogues/waterData";

const npshWaterMode: CalcMode = {
  id: "001npshawater",
  name: "NPSHa_water",
  baseQuantities: [
    {
      ...Pressure,
      name: "absolute_pressure",
      symbol: "Pa",
      value: "101325",
      type: "hidden",
    },
    {
      ...Pressure,
      name: "frictional_pressure",
      symbol: "Pfr",
    },
    {
      ...Pressure,
      name: "vapour_pressure",
      symbol: "Pvp",
      datavalues: waterData[0].data.map((d) => {
        return {
          label: `${d.temperature.value}${d.temperature.unit}`,
          value: d.pressure.value.toString(),
        };
      }),
    },
    {
      ...Density,
      datavalues: waterData[0].data.map((d) => {
        return {
          label: `${d.temperature.value}${d.temperature.unit}`,
          value: d.density.value.toString(),
        };
      }),
    },
    {
      ...Acceleration,
      name: "gravitational_acceleration",
      symbol: "g",
      value: "9.82",
      type: "hidden",
    },
    { ...Length, name: "static_head", symbol: "Hz" },
    { ...Length, name: "NPSHa", symbol: "NPSHa" },
  ],
  equation: "NPSH\u2090=Pa/\u03C1g-Pvp/\u03C1g+Hz-Pfr/\u03C1g",
};
const npshStandard: CalcMode = {
  id: "001npshastandard",
  name: "NPSHa_general",
  baseQuantities: [
    {
      ...Pressure,
      name: "absolute_pressure",
      symbol: "Pa",
      value: "101325",
    },
    {
      ...Pressure,
      name: "frictional_pressure",
      symbol: "Pfr",
    },
    {
      ...Pressure,
      name: "vapour_pressure",
      symbol: "Pvp",
    },
    { ...Density },
    {
      ...Acceleration,
      name: "gravitational_acceleration",
      symbol: "g",
      value: "9.82",
    },
    { ...Length, name: "static_head", symbol: "Hz" },
    { ...Length, name: "NPSHa", symbol: "NPSHa" },
  ],
  equation: "NPSH\u2090=Pa/\u03C1g-Pvp/\u03C1g+Hz-Pfr/\u03C1g",
};
export const npshaCalc: Calculator = {
  type: AppData.CALCULATOR,
  updatedAt: "2022-07-26",
  name: "NPSHa",
  branch: "Fluids",
  difficulty: "complex",
  inputs: [npshWaterMode, npshStandard],
  calculate: [
    {
      name: "NPSHa_water",

      equations: [
        {
          target: "NPSHa",
          expression:
            "(absolute_pressure)/(density)/(gravitational_acceleration) - (vapour_pressure)/(density)/(gravitational_acceleration) + (static_head) - (frictional_pressure)/(density)/(gravitational_acceleration)",
        },
        {
          target: "vapour_pressure",
          expression:
            "((absolute_pressure)/(density)/(gravitational_acceleration) - (NPSHa) + (static_head) - (frictional_pressure)/(density)/(gravitational_acceleration)) * (density) * (gravitational_acceleration)",
        },
        {
          target: "static_head",
          expression:
            "(NPSHa) - (absolute_pressure)/(density)/(gravitational_acceleration) + (vapour_pressure)/(density)/(gravitational_acceleration) + (frictional_pressure)/(density)/(gravitational_acceleration)",
        },
        {
          target: "frictional_pressure",
          expression:
            "((absolute_pressure)/(density)/(gravitational_acceleration) - (NPSHa) + (static_head) - (vapour_pressure)/(density)/(gravitational_acceleration)) * (density) * (gravitational_acceleration)",
        },
        {
          target: "density",
          expression:
            "((absolute_pressure) / (gravitational_acceleration) - (vapour_pressure) / (gravitational_acceleration) - (frictional_pressure) / (gravitational_acceleration)) / ((NPSHa) - (static_head))",
        },
      ],
    },
    {
      name: "NPSHa_general",

      equations: [
        {
          target: "NPSHa",
          expression:
            "(absolute_pressure)/(density)/(gravitational_acceleration) - (vapour_pressure)/(density)/(gravitational_acceleration) + (static_head) - (frictional_pressure)/(density)/(gravitational_acceleration)",
        },
        {
          target: "absolute_pressure",
          expression:
            "((NPSHa) - (static_head) + (frictional_pressure)/(density)/(gravitational_acceleration) + (vapour_pressure)/(density)/(gravitational_acceleration)) * (density) * (gravitational_acceleration)",
        },
        {
          target: "vapour_pressure",
          expression:
            "((absolute_pressure)/(density)/(gravitational_acceleration) - (NPSHa) + (static_head) - (frictional_pressure)/(density)/(gravitational_acceleration)) * (density) * (gravitational_acceleration)",
        },
        {
          target: "static_head",
          expression:
            "(NPSHa) - (absolute_pressure)/(density)/(gravitational_acceleration) + (vapour_pressure)/(density)/(gravitational_acceleration) + (frictional_pressure)/(density)/(gravitational_acceleration)",
        },
        {
          target: "frictional_pressure",
          expression:
            "((absolute_pressure)/(density)/(gravitational_acceleration) - (NPSHa) + (static_head) - (vapour_pressure)/(density)/(gravitational_acceleration)) * (density) * (gravitational_acceleration)",
        },
        {
          target: "density",
          expression:
            "((absolute_pressure) / (gravitational_acceleration) - (vapour_pressure) / (gravitational_acceleration) - (frictional_pressure) / (gravitational_acceleration)) / ((NPSHa) - (static_head))",
        },
        {
          target: "gravitational_acceleration",
          expression:
            "((absolute_pressure) / (density) - (vapour_pressure) / (density) - (frictional_pressure) / (density)) / ((NPSHa) - (static_head))",
        },
      ],
    },
  ],
};
